import { render, staticRenderFns } from "./WfUserContainerForm.vue?vue&type=template&id=94c65b16&"
import script from "./WfUserContainerForm.vue?vue&type=script&lang=js&"
export * from "./WfUserContainerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports